<template>
    <div :class="classes">
        <input
            :id="id"
            class="form__checkbox"
            type="checkbox"
            :class="disabled ? 'disabled' : ''"
            :value="value"
            :disabled="disabled"
            :checked="value"
            @input="$emit('input', $event.target.checked)"
        />
        <v-label :dusk="id" classes="label" :labelFor="id" :id="'label-' + id">
            <slot>
                {{ label }}
                <tooltip v-if="tooltip" position="right" :tooltipClasses="''">
                    <template #label>
                        <img class="information-icon" src="/imgs/icons/info_icon.svg"
                        />
                    </template>

                    <template #tooltip>
                        {{ tooltip }}
                    </template>
                </tooltip>
            </slot>
        </v-label>
    </div>
</template>

<script>
import Tooltip from '../Tooltip';

export default {
    name: "Checkbox",
    components: {
        Tooltip
    },
    props: {
        id: { type: String, required: true },
        classes: { type: String, default: "" },
        disabled: { type: Boolean, default: false },
        label: { type: String },
        value: {},
        tooltip: {
            type: String,
            default: null
        },
    }
};
</script>
